import React from "react";
import DefaultModal from "../DefaultModal";
import { useTranslation } from "react-i18next";
import CusButton from "../../mui/custom_button/CusButton";
import "./refuse-bonus.scss";

export default function RefuseBonusModal({ isOpen, closeModal, bonusName, onConfirm }) {
  const { t } = useTranslation();
  return (
    <DefaultModal miniModal isOpen={isOpen} closeModal={closeModal} classModal="refuse-bonus">
      <h1>{t("Refuse bonus")}</h1>
      <div className="refuse-bonus__content">
        <p>
          {t("If you decline the bonus, you will not be able to receive it again!", { bonusName })}
        </p>
        <p className="accent">
          {t("Are you sure you want to opt out of the bonus?", { bonusName })}
        </p>
      </div>
      <div className="refuse-bonus__buttons">
        <CusButton text="I want to receive it!" onClick={closeModal} color="green3" />
        <CusButton text="I refuse!" onClick={onConfirm} />
      </div>
    </DefaultModal>
  );
}
